// extracted by mini-css-extract-plugin
export default {"box":"refundPage_box__914oK"};